import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchService } from 'src/app/_services/search.service';

@Component({
  selector: 'app-dialog-save-search',
  templateUrl: './dialog-save-search.component.html',
  styleUrls: ['./dialog-save-search.component.scss']
})
export class DialogSaveSearchComponent implements OnInit {

  name: string
  isSaved: boolean = false
  propertyCols = []

  constructor(
    public dialogRef: MatDialogRef<DialogSaveSearchComponent>,
    private searchService: SearchService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log("DATA", this.data)
    this.propertyCols = Object.keys(this.data.criteria);
  }

  saveSearchForm(){
    
    this.data['name'] = this.name
    this.searchService.saveSearchForm(this.data)
    .subscribe(resp => {
      this.isSaved = true
    })
  }

  updateSearchForm(){

  }

  onClose(): void {
    this.dialogRef.close();
  }

}
